<template>
  <div class="right_box_main">
    <div class="listBox-item">
      <!-- 面包屑 -->
      <!-- <div class="mianbao">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/twoNetworkConvergence' }">两网融合</el-breadcrumb-item>
                    <el-breadcrumb-item>考情管理</el-breadcrumb-item>
                    <el-breadcrumb-item>申请管理</el-breadcrumb-item>
                    <el-breadcrumb-item>外出</el-breadcrumb-item>
                </el-breadcrumb>
            </div> -->

      <!-- 表格 -->
      <el-card class="publicCard">
        <!-- 搜索表单 -->
        <el-form
          :inline="true"
          :model="searchlist"
          class="demo-form-inline"
          size="mini"
        >
          <el-form-item label="姓名">
            <el-input
              v-model="searchlist.applyName"
              placeholder
            ></el-input>
          </el-form-item>
          <el-form-item label="所属机构">
            <el-cascader
              v-model="searchlist.orgId"
              :options="orgList"
              @change="handleChange"
              :show-all-levels="false"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="searchlist.approvalStatus"
              placeholder="请选择"
            >
              <el-option
                label="未审批"
                value="0"
              ></el-option>
              <el-option
                label="审批已通过"
                value="2"
              ></el-option>
              <el-option
                label="审批未通过"
                value="1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="searchlistdata"
            >查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button
              type="info"
              @click="searchlistReset"
            >重置</el-button>
          </el-form-item>
        </el-form>
        <!-- 表格主体 -->
        <div class="listBox-item">
          <div class="table_card">
            <el-table
              :data="tableData"
              :header-cell-style="{ background: '#f8fafa' }"
              size="small"
              border
              align="center"
              current-row-key
              highlight-current-row
            >
              <el-table-column
                label="序号"
                type="index"
                width="50"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="applyName"
                label="姓名"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="orgName"
                label="所属机构"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="startTime"
                label="开始时间"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="endTime"
                label="结束时间"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="leaveTimeLength"
                label="时长(小时）"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="applyReason"
                label="外出事由"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="approvalName"
                label="审批人"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="approvalStatus"
                label="状态"
              >
                <template slot-scope="scope">
                  <span v-if="tableData[scope.$index].approvalStatus==0">未审批</span>
                  <span v-if="tableData[scope.$index].approvalStatus==1">审批未通过</span>
                  <span v-if="tableData[scope.$index].approvalStatus==2">审批已通过</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="applyReason"
                label="操作"
                min-width='120'
              >
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="审核"
                    placement="top-start"
                    :enterable="false"
                  >
                    <button
                      @click="examineDialog(scope.row.id)"
                      class="tabBtn iconfont icon-shenpi shenhe"
                      v-if="scope.row.approvalStatus==0"
                    ></button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="查看"
                    placement="top-start"
                    :enterable="false"
                  >
                    <button
                      @click="lookDialog(scope.row.id)"
                      class="tabBtn iconfont icon-chakan shenhe"
                    ></button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="删除"
                    placement="top-start"
                    :enterable="false"
                  >
                    <button
                      class="tabBtn el-icon-delete tabBtn-delete"
                      @click="deleteDialog(scope.row.id)"
                    ></button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 分页 -->
        <el-pagination
          :page-size="pageConfig.pageSize"
          layout="total, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          :total="pageConfig.total"
        ></el-pagination>
      </el-card>

      <!-- 操作=》审核弹框 -->
      <el-dialog
        title="审核"
        :visible.sync="examineDialogVisible"
        width="35%"
      >
        <el-form
          ref="examineForm"
          :model="examine"
          label-width="140px"
        >
          <el-form-item label="姓名:">
            <el-input
              v-model="examine.applyName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="所属机构:">
            <el-input
              v-model="examine.orgName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="开始时间:">
            <el-input
              v-model="examine.startTime"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="结束时间:">
            <el-input
              v-model="examine.endTime"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="时长(小时):">
            <el-input
              v-model="examine.leaveTimeLength"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="外出事由:">
            <el-input
              v-model="examine.applyReason"
              disabled
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item label="图片:">
            <img
              alt
              :src="examine.photo"
              class="tbImgTwo"
              @click='show(examine.photo)'
            />
          </el-form-item>
          <el-form-item label="审批人:">
            <el-input
              v-model="examine.approvalName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="状态:">
            <el-input
              v-model="examine.approvalStatus"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="审核意见:"
            style="margin-bottom:20px"
          >
            <p style='color:red;font-size:12px'>此项为审核不通过时必填项,审核通过可忽略此项 !</p>
            <el-input
              v-model="examine.suggestion"
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              @click="shenhe(examine.id,'2')"
              type="primary"
            >审核通过</el-button>
            <el-button
              @click="shenhe(examine.id,'1')"
              type="info"
            >审核不通过</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <!-- 查看 -->
      <el-dialog
        title="查看"
        :visible.sync="lookDialogVisible"
        width="35%"
      >
        <el-form
          ref="examineForm"
          :model="examine"
          label-width="140px"
        >
          <el-form-item label="姓名:">
            <el-input
              v-model="examine.applyName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="所属机构:">
            <el-input
              v-model="examine.orgName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="开始时间:">
            <el-input
              v-model="examine.startTime"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="结束时间:">
            <el-input
              v-model="examine.endTime"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="时长(小时):">
            <el-input
              v-model="examine.leaveTimeLength"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="外出事由:">
            <el-input
              v-model="examine.applyReason"
              disabled
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item label="图片:">
            <img
              alt
              :src="examine.photo"
              class="tbImgTwo"
              @click='show(examine.photo)'
            />
          </el-form-item>
          <el-form-item label="审批人:">
            <el-input
              v-model="examine.approvalName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="状态:">
            <el-input
              v-model="examine.approvalStatus"
              disabled
            ></el-input>
          </el-form-item>
        </el-form>
      </el-dialog>

      <!-- 大图 -->
      <div
        v-if='showImg'
        @click='showImg = false'
        class="bigbox"
      >
        <img
          :src="showImgUrl"
          class="bigImg"
          alt=""
        >
      </div>
    </div>
  </div>
</template>

<script>
import { post } from "@/api/requrestHttp"
// 表格数据和分页js
import { tabdata } from "@/mixins/tabledataMix.js"
// 表单校验js
import { validatePhoneOrMobile } from "@/utils/validate.js"
export default {
  mixins: [tabdata],
  data() {
    return {
      showImg: false,
      showImgUrl: "",
      searchlist: {},
      applyType: 9,
      tableData: [],
      tableDataUrl: "",
      // 审核弹框显示隐藏
      examineDialogVisible: false,
      lookDialogVisible: false,
      examine: {},
      // 所属机构数据
      orgList: [],
    }
  },
  methods: {
    // 操作=》审核
    async examineDialog(id) {
      this.examineDialogVisible = true
      let res = await this.$http.post("/admin/attendance/apply/info/get", {
        id: id,
      })
      console.log(res)
      if (res.code !== 200) {
        this.$message.error("获取数据失败")
      }
      this.$message.success("获取数据成功")
      this.examine = res.content
      console.log(123 + this.examine.photo)
      // 判断请假类型
      const exValue = this.examine.applyType
      if (exValue == 1) {
        this.examine.applyType = "事假"
      }

      if (
        res.content.leaveTimeLength != null &&
        res.content.leaveTimeLength != undefined
      ) {
        res.content.leaveTimeLength = (+res.content.leaveTimeLength).toFixed(2)
      }

      // 判断状态类型
      const eaValue = this.examine.approvalStatus
      if (eaValue == 0) {
        this.examine.approvalStatus = "待审核"
      } else if (eaValue == 1) {
        this.examine.approvalStatus = "审核不通过"
      } else if (eaValue == 2) {
        this.examine.approvalStatus = "审核通过"
      }
      this.getPageDatas("", "leave")
    },
    //显示大图
    show: function (url) {
      this.showImg = true
      this.showImgUrl = url
    },
    // 操作=》审核
    async lookDialog(id) {
      this.lookDialogVisible = true
      let res = await this.$http.post("/admin/attendance/apply/info/get", {
        id: id,
      })
      console.log(res)
      if (res.code !== 200) {
        this.$message.error("获取数据失败")
      }
      this.$message.success("获取数据成功")
      this.examine = res.content
      console.log(123 + this.examine.photo)
      // 判断请假类型
      const exValue = this.examine.applyType
      if (exValue == 1) {
        this.examine.applyType = "事假"
      }

      if (
        res.content.leaveTimeLength != null &&
        res.content.leaveTimeLength != undefined
      ) {
        res.content.leaveTimeLength = (+res.content.leaveTimeLength).toFixed(2)
      }

      // 判断状态类型
      const eaValue = this.examine.approvalStatus
      if (eaValue == 0) {
        this.examine.approvalStatus = "待审核"
      } else if (eaValue == 1) {
        this.examine.approvalStatus = "审核不通过"
      } else if (eaValue == 2) {
        this.examine.approvalStatus = "审核通过"
      }
      this.getPageDatas("", "leave")
    },
    // 操作=》审核=》通过&&未通过
    async shenhe(id, status) {
      if (status == 1 && this.examine.suggestion == null) {
        this.$message.success("请输入审核不通过原因")
        return
      }
      let res = await this.$http.post("/admin/attendance/apply/info/verify", {
        id: id,
        approvalStatus: status,
      })
      if (res.code !== 200) {
        this.$message.error("审批数据失败")
      }
      this.$message.success("审批数据成功")
      this.examineDialogVisible = false
      this.getPageDatas("", "leave")
    },
    // 操作=》查看
    // 操作=》删除
    async deleteDialog(id) {
      const confirmResult = await this.$confirm(
        "此操作将永久删除该用户, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err)
      if (confirmResult !== "confirm") {
        return this.$message.info("已经取消删除")
      }
      let res = await this.$http.post("/admin/attendance/apply/info/delete", {
        id: id,
      })
      console.log(res)
      if (res.code !== 200) {
        this.$message.error("删除数据失败")
      }
      this.$message.success("删除数据成功")
      this.getPageDatas("", "leave")
    },
    // 所属机构
    handleChange(value) {
      if (value != null) {
        this.searchlist.orgId = value
        // this.searchlist.orgId = value[value.length - 1];
      }
    },
  },
  created() {
    post("/rbac/admin/org/info/OrgTreelist", { orgType: 1,isValid: 1,}).then((res) => {
      this.orgList = res.content
    })
  },
  mounted() {
    // this.initTableDataUrl("/admin/attendance/apply/info/list",'','leave');
  },
}
</script>

<style  scoped lang="less">
img.tbImg {
  width: 20px;
  height: 20px;
}
img.tbImgTwo {
  width: 150px;
  height: 150px;
}
.shenhe {
  color: red;
  &:hover {
    color: skyblue;
  }
}
.bigbox {
  position: fixed;
  z-index: 99999999999999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  .bigImg {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    max-width: 80%;
    max-height: 90%;
  }
}
</style>
